<template>
  <section class="page-doc-api page-doc-item">
    <op-menu :dataList="dataList"></op-menu>
    <section class="doc__content">
      <!-- <op-bread></op-bread> -->
      <!-- <transition name="fade"></transition> -->
      <router-view />
    </section>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import opMenu from "@/components/views/doc-api/menu.vue";
import opBread from "@/components/common/bread.vue";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      // dataList: state => state.apiDoc.apiDocList
    }),
    ...mapGetters({
      dataList: "apiDoc/apiDocListMenu"
    })
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("apiDoc/getApiDocList");
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    init() {
      if ([undefined, null].includes(this.$route.params.id)) {
        this.$router.push({
          name: "docApiInfo",
          params: { id: this.dataList[0].apilist[0].apiCode }
        });
      }
    }
  },
  components: {
    opMenu
    //opBread
  }
};
</script>

<style lang="less">
.page-doc-item {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  padding-top: 40px;
  align-items: flex-start;

  .doc__content {
    flex-grow: 1;
    padding-left: 60px;
  }
}
.page-doc-api {
  overflow: hidden;
  .doc-api-list {
    .api-catalog__title {
      margin-bottom: 20px;
    }
    .doc-api__content {
      li.doc-api__item {
        border-bottom: 1px solid @color-border-default;
        padding: 16px 0px;
        .api-code {
          margin-bottom: 6px;
        }
      }
    }
  }
}
</style>
